import React, { useEffect, useImperativeHandle, useState } from 'react';
import { Alert, Button, Select } from 'antd';
import axios from 'axios';
import LoadingState from './LoadingState';

/** Read-only disease-unit selection; administration is outside the explorer UI. */
export default function DiseaseUnitSelect({ value, onChange, label = "Disease unit", filterUnits,agentRef }) {
    const [units, setUnits] = useState([]);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const token = localStorage.getItem('userInfo');
    useImperativeHandle(agentRef,()=>({reload:()=>setRetry(v=>v+1),ready:()=>!busy&&!error}));
    useEffect(() => {
        const abort = new AbortController();
        setBusy(true); setError('');
        axios.get('/api/rgnet/units', { signal: abort.signal, timeout: 30000, headers: { Authorization: token } }).then(response => {
            if (abort.signal.aborted) return;
            if (response.data.code !== 200) throw new Error(response.data.msg);
            setUnits(response.data.data.units);
        }).catch(ex => { if (!abort.signal.aborted) setError("Could not load disease units. Please retry."); })
            .finally(() => { if (!abort.signal.aborted) setBusy(false); });
        return () => abort.abort();
    }, [token, retry]);
    const available = filterUnits ? units.filter(filterUnits) : units;
    const counts = new Map();
    available.forEach(unit => counts.set(unit.name, (counts.get(unit.name) || 0) + 1));
    const key = unit => JSON.stringify([unit.datasetVersion, unit.unitId || null]);
    const selected = typeof value === 'string' ? { datasetVersion: value, unitId: null } : value;
    return <div className="rgnet-disease-unit">
        <label htmlFor={label === "Disease unit" ? 'rgnet-disease-unit' : 'rgnet-disease-unit-b'}>{label}</label>
        <Select id={label === "Disease unit" ? 'rgnet-disease-unit' : 'rgnet-disease-unit-b'} aria-label={label} loading={busy} disabled={busy} showSearch optionFilterProp="label"
            placeholder={busy ? "Loading disease units…" : "Select a disease unit"} allowClear value={selected && available.some(unit=>key(unit)===key(selected)) ? key(selected) : undefined} onChange={value => { const row = units.find(unit => key(unit) === value); onChange(row ? { datasetVersion: row.datasetVersion, unitId: row.unitId || null } : null); }}
            options={available.map((unit,index) => ({ value: key(unit), label: `${unit.name || "Disease name not supplied"}${counts.get(unit.name) > 1 ? ` (${unit.active ? "Active data" : "Historical data"}, list item ${index+1})` : ''}` }))} />
        {busy && <LoadingState title={"Loading disease units…"} compact />}
        {error && <Alert type="error" message={error} action={<Button size="small" onClick={() => setRetry(attempt => attempt + 1)}>Retry loading</Button>} />}
    </div>;
}
